import api from "../apiConfig";

const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/attendance?${p}`);
  },
  getById(id) {
    return api.get(`/api/v1/attendance/${id}`);
  },
  getMyTeam(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/user/my-employee-details?${p}`);
  },

  //Daily check attendance per user
  dailyCheckAttendance() {
    return api.get(`/api/v1/attendance-check`);
  },
  //attendance status
  attendanceStatus() {
    return api.get(`/api/v1/user-state`);
  },
  //attendance last 10 days
  forTenDays() {
    return api.get(`/api/v1/attendance-recent`);
  },
  //attendance for month if date null get all
  forMyAttendance(date) {
    const params = date ? `?date=${date}` : "";
    return api.get(`/api/v1/attendance-user-month${params}`);
  },
  remotlyCheckInOut(data) {
    return api.post(`/api/v1/checkin-out-remotely`, data);
  },
  recalculateAttendance(data) {
    return api.get(
      `/api/v1/recalculate?user_id=${data.id}&specific_date=${data.date}`
    );
  },
  recalculateAllAttendance(date) {
    return api.get(`/api/v1/recalculate?specific_date=${date}`);
  },
  getDayAttendanceLog(data) {
    return api.get(
      `/api/v1/attendance-log?user_id=${data.user_id}&date=${data.date}`
    );
  },
  updateDayAttendanceLog(data) {
    return api.post(`/api/v1/attendance-log`, data);
  },
  updateDayAttendanceCheckInOut(data) {
    return api.put(`/api/v1/attendance/${data.id}`, data);
  },
  deleteAttendance(id) {
    return api.delete(`/api/v1/attendance/${id}`);
  },
  clearAttendance(data) {
    const { id, type } = data;
    return api.put(`/api/v1/attendance/clear/${id}`, { type });
  },
};
